import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useRetainersDashboardUserDetails = () => {
    const { getDataAsync } = useApi();

    const getUserDetailsByIdApiCall = useCallback(
        async (userId) => {
            if (userId) {
                const response = await getDataAsync("getUserDetailsById", {
                    urlParams: [{ name: "$userId", value: userId }],
                });

                const result = response.status === 204
                    ? null
                    : response.json();

                return result;

            } else {
                return null;
            }
        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useUserById = (userId) =>
            useQuery(["userDetailsById", userId], () =>
                getUserDetailsByIdApiCall(userId)
            );

        return {
            useUserById,
        };
    }, [getUserDetailsByIdApiCall]);
};

export default useRetainersDashboardUserDetails;

export const useRateCard = () => {
    const { getDataAsync } = useApi();
    const getRateCardByIdApiCall = useCallback(
        async (rateCardId) => {
            const response = await getDataAsync("getRateCardById", {
                urlParams: [{ name: "$rateCardId", value: rateCardId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;

        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useRateCardById = (rateCardId) =>
            useQuery(["rateCardById", rateCardId], () =>
                getRateCardByIdApiCall(rateCardId)
            );

        return {
            useRateCardById,
        };
    }, [getRateCardByIdApiCall]);
};
